import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, Share2, ArrowLeft } from "lucide-react";
import { getShare } from "../lib/api";
import { AnswerDisplay } from "../components/AnswerDisplay";
import { Disclaimer } from "../components/Disclaimer";

export default function SharePage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    getShare(id)
      .then(setData)
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-base font-semibold text-slate-600 hover:text-teal-700 mb-6"
        data-testid="share-home-link"
      >
        <ArrowLeft className="w-4 h-4" /> Ask your own question
      </Link>

      {loading ? (
        <div className="py-20 text-center">
          <Loader2 className="w-10 h-10 text-teal-600 animate-spin mx-auto" />
        </div>
      ) : notFound || !data ? (
        <div className="bg-white border-2 border-slate-200 rounded-2xl p-8 text-center" data-testid="share-not-found">
          <p className="text-lg text-slate-600">This shared answer could not be found.</p>
        </div>
      ) : (
        <>
          <div className="flex items-center gap-2 text-teal-700 font-semibold text-sm uppercase tracking-wider mb-3">
            <Share2 className="w-4 h-4" /> Shared answer
          </div>
          <div className="mb-6">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-500 mb-2">
              Question
            </h2>
            <div className="bg-white border-2 border-slate-200 rounded-2xl p-5" data-testid="share-question">
              <p className="text-xl text-slate-900 font-medium leading-relaxed">{data.question}</p>
            </div>
          </div>
          <AnswerDisplay result={data} done={true} shareEnabled={false} />
          <div className="mt-6">
            <Disclaimer compact />
          </div>
        </>
      )}
    </div>
  );
}
